(() => {
  if (window.ThemeBlogPagination) {
    window.ThemeBlogPagination.init(document);
    return;
  }

  function collect(scope, selector) {
    const nodes = [];

    if (scope instanceof Element && scope.matches(selector)) {
      nodes.push(scope);
    }

    if (scope?.querySelectorAll) {
      nodes.push(...scope.querySelectorAll(selector));
    }

    return nodes;
  }

  function announce(message) {
    if (window.PegasusTheme?.announce) {
      window.PegasusTheme.announce(message);
      return;
    }

    const status = document.querySelector('[data-theme-status]');
    if (status) status.textContent = message;
  }

  async function fetchPage(targetUrl) {
    const requestUrl = new URL(targetUrl, window.location.href);
    const response = await fetch(requestUrl.toString(), {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    if (!response.ok) {
      throw new Error('Unable to load more articles.');
    }

    return {
      markup: await response.text(),
      url: response.url || requestUrl.toString(),
    };
  }

  async function loadMoreArticles(section, button) {
    const sectionId = String(section?.dataset?.blogSectionId || '').trim();
    const grid = section?.querySelector('[data-blog-grid]');
    const currentPagination = button?.closest('[data-blog-pagination]');
    const targetUrl = button?.href;

    if (!sectionId || !grid || !currentPagination || !targetUrl) {
      throw new Error('Unable to load more articles.');
    }

    const label = button.querySelector('[data-load-more-label]');
    const originalLabel = label?.textContent || '';

    button.dataset.loading = 'true';
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-disabled', 'true');

    if (label) {
      label.textContent = button.dataset.loadingLabel || 'Loading…';
    }

    try {
      const pageResponse = await fetchPage(targetUrl);
      const parsedDocument = new DOMParser().parseFromString(pageResponse.markup, 'text/html');
      const nextSection = collect(parsedDocument, '[data-blog-section-id]').find((candidate) => (
        candidate.dataset.blogSectionId === sectionId
      ));
      const incomingItems = nextSection ? collect(nextSection, '[data-blog-article]') : [];
      const incomingPagination = nextSection?.querySelector('[data-blog-pagination]');

      if (!nextSection || !incomingItems.length) {
        throw new Error('Unable to load more articles.');
      }

      incomingItems.forEach((item) => grid.append(item));

      if (incomingPagination) {
        currentPagination.replaceWith(incomingPagination);
      } else {
        currentPagination.remove();
      }

      window.history.pushState(
        { ...window.history.state, blogLoadMore: true },
        '',
        pageResponse.url,
      );

      grid.dispatchEvent(new CustomEvent('shopify:section:load', {
        bubbles: true,
        detail: { sectionId },
      }));

      const loadedArticleCount = grid.querySelectorAll('[data-blog-article]').length;
      announce(`${loadedArticleCount} articles loaded.`);
    } catch (error) {
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
      delete button.dataset.loading;

      if (label) label.textContent = originalLabel;

      throw error;
    }
  }

  async function replaceBlogSection(currentSection, targetUrl) {
    const sectionId = String(currentSection?.dataset?.blogSectionId || '').trim();

    if (!sectionId || !targetUrl) {
      throw new Error('Unable to update blog articles.');
    }

    const pageResponse = await fetchPage(targetUrl);
    const parsedDocument = new DOMParser().parseFromString(pageResponse.markup, 'text/html');
    const replacement = collect(parsedDocument, '[data-blog-section-id]').find((candidate) => (
      candidate.dataset.blogSectionId === sectionId
    ));

    if (!replacement) {
      throw new Error('Unable to update blog articles.');
    }

    currentSection.replaceWith(replacement);
    replacement.dispatchEvent(new CustomEvent('shopify:section:load', {
      bubbles: true,
      detail: { sectionId },
    }));
  }

  function init(scope = document) {
    collect(scope, '[data-blog-section-id]').forEach((section) => {
      if (section.dataset.blogPaginationInitialized === 'true') return;
      section.dataset.blogPaginationInitialized = 'true';

      section.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;

        const loadMoreButton = event.target.closest('[data-blog-load-more]');

        if (!loadMoreButton || !section.contains(loadMoreButton)) return;
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        event.preventDefault();

        if (loadMoreButton.dataset.loading === 'true') return;

        const targetUrl = loadMoreButton.href;

        loadMoreArticles(section, loadMoreButton).catch(() => {
          window.location.assign(targetUrl);
        });
      });
    });
  }

  window.ThemeBlogPagination = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  window.addEventListener('popstate', () => {
    const section = document.querySelector('[data-blog-section-id]');

    if (!section) return;

    replaceBlogSection(section, window.location.href).catch(() => {
      window.location.reload();
    });
  });
})();
